// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;
  margin-bottom: ${props => (props.withMargin ? props.theme.metrics.margin : '0')}px;

  width: 100%;
  height: auto;

  background-color: ${({ theme }) => theme.colors.cardBackground};
  box-shadow: ${({ theme }) => theme.colors.boxShadow};
`;

const Container = styled.div`
  flex: 1;
  padding: ${({ theme, noPadding }) => (noPadding ? '0' : theme.metrics.margin)}px;
  -webkit-transition: height 2s; 
  -moz-transition: height 2s; 
  -ms-transition: height 2s; 
  -o-transition: height 2s; 
  transition: height 2s;
`;

const Title = styled.div`
  padding: ${({ theme }) => theme.metrics.margin}px;
  display: flex;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.fonts.style.secondaryCardTitle.color};
  cursor: ${props => (props.collapsable ? 'pointer' : 'cursor')};

  justify-content: space-between;
  align-content: center;
  align-items: center;
`;

const TitleText = styled.h2`
  display: inline-block;
  margin: 0;
  font-size: ${({ theme }) => theme.fonts.style.secondaryCardTitle.fontSize}px;
  font-weight: ${({ theme }) => theme.fonts.weights.bolder};
`;

const CollapseIcon = styled.i`
  width: 19px;
  height: 19px;
  margin-right: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const RightTitleItemsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
  align-items: center;
`;

type State = {
  collapsable: boolean;
  collapsed: boolean;
}

type Props = {
  title: string,
  children: any,
  defaultCollapsed: boolean;
  noPadding?: boolean;
  TitleExtraRightItem?: any;
  collapsable?: boolean;
  withMargin?: boolean;
  theme: any;
}

class TitledCard extends React.Component<Props, State> {
  static defaultProps = {
    defaultCollapsed: false,
  }

  constructor(props: Props) {
    super(props);

    this.state = {
      collapsable: !!props.collapsable,
      collapsed: props.defaultCollapsed,
    };
  }

  onCollapse = () => {
    if (!this.state.collapsable) {
      return;
    }

    const collapsed = this.state.collapsed;
    this.setState({ collapsed: !collapsed });
  }

  render() {
    const { title, children, collapsable, noPadding, withMargin, TitleExtraRightItem } = this.props;
    const { collapsed } = this.state;
    const direction = 'keyboard_arrow_' + (collapsed ? 'down' : 'up');

    return (
      <Wrapper withMargin={withMargin}>
        <Title collapsable={collapsable} onClick={() => this.onCollapse()}>
          <TitleText>{title}</TitleText>
          <RightTitleItemsContainer>
            { TitleExtraRightItem && TitleExtraRightItem}
            { collapsable &&
            <CollapseIcon className="material-icons">{direction}</CollapseIcon>
            }
          </RightTitleItemsContainer>
        </Title>
        { !collapsed &&
          <Container noPadding={noPadding}>
            {children}
          </Container>
        }
      </Wrapper>
    );
  }
}

export default withTheme(TitledCard);



// WEBPACK FOOTER //
// ./src/common/components/cards/TitledCard.js